<template>
  <v-app>
    <AppBar />
    <v-main>
      <router-view />
    </v-main>
    <HeroSection />
    <FooterSection />
    <SocialSidebar />
    <WhatsappFloat />

    <!-- 📢 Dialogo flotante -->
    <v-dialog
      v-model="showNotice"
      max-width="520"
      persistent
      transition="dialog-bottom-transition"
      overlay-color="black"
      overlay-opacity="0.7"
    >
      <v-card class="rounded-xl">
        <v-card-title class="headline primary white--text">
          📢 ¡Nuevo Curso Disponible!
        </v-card-title>

        <v-card-text class="py-6 text-subtitle-1 text-center">
          El <strong>lunes 23 de septiembre</strong> comienza el
          <span class="blue--text font-weight-bold">Curso de Java</span>. <br /><br />

          💰 <strong class="red--text">Precio promocional: S/ 350 mensual</strong><br />
          📅 <strong>Duración:</strong> 6 meses <br /><br />

          ¡Aprende desde cero y da el primer paso en tu carrera como desarrollador!
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center py-4">
          <!-- Botón de Inscribirse -->
          <v-btn
            color="success"
            class="white--text px-6"
            rounded
            large
            :href="whatsappLink"
            target="_blank"
          >
            <v-icon left>mdi-whatsapp</v-icon>
            Inscribirse
          </v-btn>

          <!-- Botón de Cerrar -->
          <v-btn color="grey darken-1" text class="ml-4" @click="closeNotice">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import AppBar from "./components/AppBar.vue";
import HeroSection from "./components/HeroSection.vue";
import FooterSection from "./components/FooterSection.vue";
import SocialSidebar from "./components/SocialSidebar.vue";
import WhatsappFloat from "./components/WhatsappFloat.vue";

export default {
  name: "App",
  components: {
    AppBar,
    HeroSection,
    FooterSection,
    SocialSidebar,
    WhatsappFloat,
  },
  data: () => ({
    showNotice: false,
    whatsappNumber: "+51917915824",
  }),
  computed: {
    whatsappLink() {
      const message =
        "Hola, quiero inscribirme en el Curso de Java que inicia el 23 de septiembre.";
      return `https://wa.me/${this.whatsappNumber}?text=${encodeURIComponent(message)}`;
    },
  },
  mounted() {
    // Mostrar SIEMPRE al recargar
    this.showNotice = false;
  },
  methods: {
    closeNotice() {
      this.showNotice = false;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
}

.v-application--wrap {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
